// dependecies
import $ from "jquery";
import _ from "underscore";
import StateManager from "./StateManager";

/* -------------------------
    INIT
------------------------- */

$(window).on(StateManager.CONTENT_READY, function(event, node) {
  $(node)
    .find(".js-scuba__content")
    .each(function(i, el) {
      new Scuba_Content(el);
    });
});

/* --------------------------------------------------

    CLASS

-------------------------------------------------- */

function Scuba_Content() {
  this.initialize.apply(this, arguments);
}

$.extend(Scuba_Content.prototype, {
  initialize: function(el) {
    this.uid = _.uniqueId("scuba-");
    var namespace = "." + this.uid;
    this.el = el;
    this.$el = $(el);
    this.$elBody = this.$el.find(".js-scuba__section__body");
    this.$page = this.$el.closest(".js-scuba__page");
    this.$page.on("scuba:dispose" + namespace, $.proxy(this.dispose, this));

    this.$overlay = $('<div class="c-scuba__content__overlay"></div>');
    this.$overlay.appendTo(this.el);
    this.$overlay.on("click", function(event) {
      event.preventDefault();
      // force le scroll vers la dernière page de contenu
      $(window).trigger("scuba:stateChange", [
        StateManager.getCurrentState(true)
      ]);
    });

    this.$page.addClass("has-scuba-content");

    // raccourcis
    this.$main = $(".js-scuba__main").first();
    this.$window = $(window);
    this.$body = $(document.body);

    // écouteur de changement du layout
    this.$body.on(
      "layout:change" + namespace,
      $.proxy(this.invalidateLayout, this)
    );
    this.invalidateLayout(null, this.$body.data("layout"));
  },

  dispose: function() {
    var namespace = "." + this.uid;
    this.$window.off(namespace);
    this.$body.off(namespace);
    this.$page.off(namespace);
  },

  invalidateLayout: function(event, layout) {
    if (!layout) return;

    var namespace = "." + this.uid;
    if (layout === "HorizontalLayout") {
      // écouteur de scroll et resize
      this.$window.on(
        "scroll" + namespace,
        $.proxy(this.window_scrollHandler, this)
      );
      this.$window.on(
        "resize" + namespace,
        $.proxy(this.window_resizeHandler, this)
      );
      // écouteur changement des pages
      this.$page.on(
        "scuba:nextPagesChanged" + namespace,
        $.proxy(this.invalidatePosition, this)
      );
      // initialisation
      this.invalidatePosition();
    } else {
      // suppr des ecouteurs
      this.$window.off(namespace);
      this.$page.off("scuba:nextPagesChanged" + namespace);
      // nettoyage
      this.$el.css("width", "");
      this.$el.removeClass("is-overflow");
    }
  },

  window_scrollHandler: function() {
    this.invalidatePosition();
  },

  window_resizeHandler: function() {
    this.invalidatePosition();
  },

  invalidatePosition: function() {
    var elBodyWidth = this.$elBody.outerWidth();
    //            console.log('invalidatePosition()', elBodyWidth);
    if (!elBodyWidth) return; // l'élément est masqué

    var windowWidth = this.$window.width();
    var scrollLeft = this.$window.scrollLeft();
    var pageLeft = this.$page.offset().left - scrollLeft;

    // décalage par rapport aux sections de la même page
    var prevOffset = this.$el.offset().left - this.$page.offset().left;

    var visibleWidth = Math.max(0, windowWidth - pageLeft) - prevOffset;
    visibleWidth = Math.min(visibleWidth, this.$main.width());

    this.$el.css("width", visibleWidth);
    this.$el.toggleClass("is-overflow", visibleWidth < elBodyWidth + 20);
  }
});



// WEBPACK FOOTER //
// ./scripts/scuba/Content.js